// Chat models for pin-based messaging and reactions

export enum MessageType {
  TEXT = 'text',
  IMAGE = 'image',
  EMOJI = 'emoji',
  SYSTEM = 'system'
}

export interface ChatMessage {
  id: string;
  pinId: string;
  text: string;
  senderId: string;
  senderName: string;
  timestamp: Date;
  messageType: MessageType;
  emoji?: string; // populated when messageType === 'emoji'
  reactions?: Record<string, number>; // emoji -> count
  userReactions?: string[]; // emojis the current user has reacted with
}

export interface EmojiReaction {
  id: string;
  emoji: string;
  scale: number;
  opacity: number;
  position: { x: number; y: number };
}

export interface TypingUser {
  userId: string;
  userName: string;
  timestamp: Date;
}

export interface ChatState {
  messages: ChatMessage[];
  reactions: Record<string, number>;
  typingUsers: TypingUser[];
  isConnected: boolean;
  isLoading: boolean;
}

export const AVAILABLE_EMOJIS = ['👍🏾', '❤️', '😂', '😮', '🙏🏾', '😡'];

export interface ChatDocumentData {
  id?: string;
  pinId: string;
  text: string;
  senderId: string;
  senderName: string;
  timestamp: Date;
  messageType: MessageType;
  emoji?: string;
  reactions?: Record<string, number>;
  userReactions?: string[];
}

export interface ReactionDocumentData {
  pinId: string;
  emoji: string;
  userId: string;
  timestamp: Date;
}

export interface TypingDocumentData {
  pinId: string;
  userId: string;
  userName: string;
  timestamp: Date;
}
